import React from "react";
import { connect } from "react-redux";
import { Form, Modal } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { CloseAdminModalIcon } from "../../assets";
import { EMPTY_STRING, ELIGIBILITY_OPTIONS } from "../../constants";
import CustomSvg from "../../shared/components/custom-svg/CustomSvg";
import RoundedButton from "../../shared/components/buttons/RoundedButton";
import SurveyFormField from "../../shared/components/surveyFormField/SurveyFormField";

const EligibleCountryModal = ({
  show,
  onClose,
  userChoice,
  allCountries,
  allowedCountries,
  onSubmit = () => {},
}) => {
  const {
    watch,
    register,
    formState: { errors },
  } = useFormContext();

  const isEligibleToBuy = watch("isEligibleToBuy");

  return (
    <Modal
      size="lg"
      // centered
      keyboard
      show={show}
      onHide={onClose}
      backdrop="static"
      animation={false}
      dialogClassName="eligible-country-modal"
    >
      <CustomSvg
        src={CloseAdminModalIcon}
        className="base-modal-close"
        onClick={onClose}
      />
      <Modal.Body className="position-relative">
        <div>
          <div className="question-heading">
            Would you like to see the properties you selected in countries where
            you are not eligible to buy?
          </div>
          {errors.countriesLikeToLiveIds && (
            <div className="error">{errors.countriesLikeToLiveIds.message}</div>
          )}
          <div className="d-flex flex-column flex-md-row gap-1 gap-md-5 eligibility-radio-group">
            <Form.Check
              className="mb-0"
              {...register("isEligibleToBuy")}
              name="isEligibleToBuy"
              type="radio"
              label="Yes"
              value={ELIGIBILITY_OPTIONS.YES}
            />
            <Form.Check
              className="mb-0"
              {...register("isEligibleToBuy")}
              name="isEligibleToBuy"
              type="radio"
              label="No"
              value={ELIGIBILITY_OPTIONS.NO}
            />
          </div>
          {isEligibleToBuy == ELIGIBILITY_OPTIONS.YES && (
            <div className="form-fields modal-form-fields">
              {allCountries
                ?.filter(
                  (country) =>
                    userChoice?.includes(country.id) &&
                    !allowedCountries.includes(country.id)
                )
                .map((country) => (
                  <SurveyFormField
                    name="countriesLikeToLiveIds"
                    key={country.id}
                    variant="radio"
                    label={country.name}
                    value={country.id}
                    multiple
                    endAdornment={
                      <div className="position-absolute flags-adornment">
                        <img
                          src={country.flag}
                          className="country-flag"
                          alt={EMPTY_STRING}
                        />
                      </div>
                    }
                  />
                ))}
            </div>
          )}
          <div className="mt-4 d-flex justify-content-center gap-3">
            <RoundedButton
              type="button"
              className="px-4 px-md-5 py-1"
              onClick={onSubmit}
            >
              Submit
            </RoundedButton>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  allCountries: state.countryReducer.allCountries,
});

export default connect(mapStateToProps, null)(EligibleCountryModal);
